
<table class="width-100per">
  <thead>
    <tr class="border-bottom-0px">
      <td>
        <div class="printheader-space">&nbsp;</div>
      </td>
    </tr>
  </thead>
  <tbody>
    <tr class="border-bottom-0px">
      <td>
        <div class="content">
          <router-outlet></router-outlet>
          <router-outlet name="print"></router-outlet>
          <!--<router-outlet name="eggsource"></router-outlet>
          <router-outlet name="folliculargrowth"></router-outlet>
          <router-outlet name="pickupdetails"></router-outlet>
          <router-outlet name="oocytequality"></router-outlet>
          <router-outlet name="spermsourcedetails"></router-outlet>
          <router-outlet name="semendataanalysis"></router-outlet>
          <router-outlet name="inseminationlog"></router-outlet>
          <router-outlet name="embryotransfer"></router-outlet>-->
        </div>
      </td>
    </tr>
  </tbody>
  <tfoot>
    <tr class="border-bottom-0px">
      <td>
        <div class="printfooter-space">&nbsp;</div>
      </td>
    </tr>
  </tfoot>
</table>




<div>
  <div class="printheader">
    <!--<div class="card bg-color-transparent">
      <div class="card-header bg-color-transparent text-align-center padding-left-0px padding-top-0px padding-bottom-0px padding-right-0px">
        <div class="col-md-12 padding-left-0px">
          <div class="row margin-left-0px">
            <div class="col-md-1 padding-right-30px">
              <img src="Hlogo.png" class="user-image-circle-65px img6">
              </div>

            <div class="col-md-11">

              <div class="row margin-left-0px">
                <label class="margin-bottom-0px font-weight-normal font-family">{{l.ReportHeaderTitle}}</label>
              </div>
              <div class="row margin-left-0px">
                <label class="margin-bottom-0px font-weight-normal font-family">{{l.ReportHeaderCaption}}</label>
              </div>

            </div>

          </div>
        </div>
      </div>
      <div class="card-body padding-top-0px padding-bottom-0px">

      </div>

    </div>-->
    <!--<router-outlet name="printheaderview"></router-outlet>-->
  </div>
  <!--<div class="printfooter">
    <router-outlet name="printfooterview"></router-outlet>
  </div>-->
  <div class="printfooter">

    <div class="card footerborder-top">

      <div class="card-header border-bottom-0px padding-bottom-0px padding-top-5px padding-left-0px padding-right-0px">

      </div>
      <div class="card-body padding-top-0px padding-bottom-0px background-color-wt padding-left-0px">
        <div class="row margin-left-0px margin-right-5px">

          <div class="col-md-8 footerborder-right padding-left-5px padding-right-5px">

            <div class="row margin-left-0px">
              <label class="margin-bottom-0px font-weight-normal font-family">{{ClientHeaderFooterLine1}}</label>
            </div>
            <div class="row margin-left-0px">
              <label class="margin-bottom-0px font-weight-normal font-family">{{ClientHeaderFooterLine2}}</label>
            </div>

          </div>

          <div class="col-md-3 padding-left-0px padding-right-0px"></div>

          <div class="col-md-1 padding-left-0px padding-right-0px">

            <div class="row margin-left-0px">
              <label class="margin-bottom-0px font-weight-normal font-family">
                <qrcode class="padding-top-0px padding-bottom-0px" [qrdata]="BillNumber" [size]="90" [level]="'M'"></qrcode>
              </label>
            </div>

          </div>

        </div>
        <!--<div class="row">
          <div class="col-md-9">

          </div>
          <div class="col-md-3">
            <label class="margin-bottom-0px font-family13px">Print Taken: {{Date | date:'dd-MMM-yyyy'}}</label>
          </div>
        </div>-->
        <!--<div class="row">
          <div class="col-print-9">

          </div>
          <div class="col-print-3">
            <label class="margin-bottom-0px font-family13px footer_info_Mh"></label>
          </div>
        </div>-->
      </div>

    </div>

  </div>

</div>
